export default __webpack_public_path__ + "static/media/BookedTime.7da51b92.svg";